export default __webpack_public_path__ + "static/media/P5.8ebc04a9.svg";